/* eslint-disable no-cond-assign */
// Luhn algorithm (mod 10 algorithm)
const luhnCheck = (values: string) => {
  if (/[^\d\s-]+/.test(values)) return false;
  let nCheck = 0;
  let bEven = false;
  const value = values.replace(/\D/g, '');

  for (let n = value.length - 1; n >= 0; n -= 1) {
    const cDigit = value.charAt(n);
    let nDigit = Number.parseInt(cDigit, 10);
    if (bEven) {
      if ((nDigit *= 2) > 9) {
        nDigit -= 9;
      }
    }
    nCheck += nDigit;
    bEven = !bEven;
  }

  return (nCheck % 10) === 0;
};

const isValidAmexCardNumberV2 = (values: string) => {
  if (values === undefined || values.replace(/\s|-/g, '').length < 15) return false;
  if (values.slice(0, 2) !== '37' && values.slice(0, 2) !== '34') return false;
  return luhnCheck(values);
};

export default isValidAmexCardNumberV2;
